import { LayoutDashboard } from "lucide-react";
import { NavigationItem } from "../../types";
import { BuilderContext } from "../context";

/**
 * Dashboard is the role-adaptive home. For owners/admins it also surfaces the
 * Owner Dashboard (CEO command — Sales/Marketing/Ops tabs) here, promoted out
 * of Admin so the executive overview lives with the home dashboard.
 *
 * Access controls are preserved exactly from the pre-restructure nav:
 *   - Dashboard home  → canViewDashboard          (unchanged)
 *   - Owner Dashboard → isAdmin && showAdminMenu  (its original Admin gate)
 * Each is gated independently so neither loses nor gains audience.
 */
export function buildDashboardSection(ctx: BuilderContext): NavigationItem | null {
  const { isAdmin, featureFlags } = ctx;

  const homeVisible = featureFlags.canViewDashboard;
  const ownerVisible = isAdmin && featureFlags.showAdminMenu;

  if (!homeVisible && !ownerVisible) return null;

  // No Owner Dashboard → keep Dashboard as a plain link (original leaf behavior).
  if (!ownerVisible) {
    return {
      id: "dashboard",
      name: "Dashboard",
      href: "/dashboard",
      icon: LayoutDashboard,
      visible: true,
      order: 0,
    };
  }

  const children: NavigationItem[] = [];
  if (homeVisible) {
    children.push({ id: "dashboard-home", name: "Dashboard", href: "/dashboard" });
  }
  children.push({ id: "owner-dashboard", name: "Owner Dashboard", href: "/admin/owner" });

  return {
    id: "dashboard",
    name: "Dashboard",
    href: homeVisible ? "/dashboard" : "/admin/owner",
    icon: LayoutDashboard,
    visible: true,
    order: 0,
    children,
  };
}
